import { handleRoute } from "../https";

export async function findCompanyMovements({
  companyId,
}: {
  companyId: string;
}) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/movements`,
  });
  return res;
}
